function AcctsCustomizationRetrievalService($resource, $window) {
    return $resource(__styleEnv__ + 'customizations/:accu/:accu:suffixPath',
        {
            suffixPath: 'AccountsCustomization.json',
            accu: '@accu'
        },
        {
            query: {
                method: 'GET',
                isArray: false,
                cache: true
            }
        }
    );
}
AcctsCustomizationRetrievalService.$inject = ['$resource', '$window'];
export default AcctsCustomizationRetrievalService;
